import { arrayOf, bool, number, shape, string } from 'prop-types'
import { uriQueryInDoubleQuotedAttr } from 'xss-filters'

import { formatPathWithLanguage } from 'shared/utils/url'
import SliderHorizontal from 'views/components/organisms/SliderHorizontal'
import HorizontalSliderItem from 'views/components/organisms/SliderHorizontal/ProductSliderItem'
import { MAX_VISIBLE_ITEM_FOR_MULTILINE_SLIDER } from 'views/consts'
import withMountPoints from 'views/enhancers/withMountPoints'
import { mountPointsType } from 'views/utils/propTypes'
import ProductType from 'views/utils/propTypes/api/Product_v1'
import { sizesPropType } from 'views/utils/propTypes/img'

const SliderComponent = ({
  items: itemsProp,
  metadata,
  moreLinkUrl,
  mountPoints,
  noSlider,
  searchLink,
  wid,
  pid,
  title,
  lazyLoadAll,
  imageSizes,
  imageMinWidth,
  imageMaxWidth,
  redirectToCart,
  excludedProducts,
  publicRuntimeConfig: {
    publicConfig: { tenant, language },
  },
  showBuyButton,
  widgets,
  ...rest
}) => {
  let products = itemsProp
  let itemsForLazyLoad

  if (noSlider) {
    products = itemsProp.slice(0, MAX_VISIBLE_ITEM_FOR_MULTILINE_SLIDER)
    itemsForLazyLoad = itemsProp.slice(MAX_VISIBLE_ITEM_FOR_MULTILINE_SLIDER)
  }
  const formatPath = formatPathWithLanguage(tenant)(language)
  const moreLinkUrlFormatted = moreLinkUrl ? formatPath(moreLinkUrl) : undefined
  const finalMoreLinkUrl = searchLink
    ? `${mountPoints.getSearchProductsList(itemsProp, { wid })}`
    : moreLinkUrlFormatted

  const items = products.map((product, idx) => (
    <HorizontalSliderItem
      key={product.id}
      product={product}
      contextPid={pid}
      metadata={metadata}
      noSlider={noSlider}
      showBuyButton={showBuyButton}
      thumbnail
      index={idx}
      lazyLoad={lazyLoadAll || null}
      imageSizes={imageSizes}
      imageMinWidth={imageMinWidth}
      imageMaxWidth={imageMaxWidth}
      redirectToCart={redirectToCart}
      wid={wid}
    />
  ))

  return (
    <SliderHorizontal
      {...rest}
      title={title}
      items={items}
      metadata={metadata}
      itemsForLazyLoad={itemsForLazyLoad}
      moreLinkUrl={
        finalMoreLinkUrl?.length
          ? uriQueryInDoubleQuotedAttr(decodeURIComponent(finalMoreLinkUrl))
          : null
      }
      noSlider={noSlider}
      redirectToCart={redirectToCart}
      showBuyButton={showBuyButton}
      wid={wid}
      widgets={widgets}
      excludedProducts={excludedProducts}
    />
  )
}

SliderComponent.propTypes = {
  ...SliderHorizontal.propTypes,
  excludedProducts: string,
  items: arrayOf(shape(ProductType)),
  metadata: shape({}),
  mountPoints: mountPointsType.isRequired,
  pid: string,
  title: string,
  searchLink: bool,
  imageMinWidth: number,
  imageMaxWidth: number,
  imageSizes: sizesPropType,
  publicRuntimeConfig: shape({
    publicConfig: shape({
      tenant: string.isRequired,
      language: string.isRequired,
    }).isRequired,
  }).isRequired,
  redirectToCart: bool,
  widgets: shape({}),
  showBuyButton: bool,
}

SliderComponent.defaultProps = {
  ...SliderHorizontal.defaultProps,
  excludedProducts: null,
  items: null,
  metadata: {},
  pid: null,
  title: null,
  searchLink: false,
  imageMinWidth: null,
  imageMaxWidth: null,
  imageSizes: null,
  widgets: null,
  redirectToCart: false,
  showBuyButton: false,
}

export default withMountPoints(SliderComponent)
